<template>
    <div id="jointOrderAdd">
        <van-form ref="form" @submit="onSubmit" validate-trigger="onBlur" label-width="110px" input-align="right">
            <van-field required v-model="form.phone"  type="tel" name="phone" label="手机号" @change="isCheck =false" placeholder="点击填写" maxlength="11" :rules="[{ required: true, message: '请填写手机号' },{ validator :validPhone, message: '请输入正确手机号' },{ validator:validPhoneRepeat, message: '手机号已存在'}]" />
             <van-field required v-model="form.name" name="name" label="姓名" placeholder="点击填写" :rules="[{ required: true, message: '请填写姓名' }]" />
            <van-field required readonly clickable name="cityId" :value="cityText" label="城市-行政区划" placeholder="点击选择>" @click="showCity = true" :rules="[{ required: true, message: '请选择所在城市' }]" />
         
             <van-field required v-model="form.address" name="address" label="详细地址" placeholder="点击填写" :rules="[{ required: true, message: '请填写详细地址' }]" />
             <van-field v-model="form.remark" rows="2" autosize label="备注" type="textarea" maxlength="200" placeholder="请输入备注" show-word-limit />
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" :loading="saveLoad" :disabled="saveLoad" native-type="submit">保存</van-button>
            </div>
        </van-form>
        <!-- 城市 -->
        <van-popup v-model="showCity" position="bottom">
            <van-picker show-toolbar :columns="cityList" value-key="name"  @confirm="confirmCity" @cancel="showCity = false" />
        </van-popup>
        <van-popup v-model="showRepeat"  closeable
  close-icon="close"
  position="center"
  :style="{ height: '50%' ,width:'90%',padding:'15px'}">
            <h4 style="padding-top:30px;line-height:40px;
    text-align: center;">该客户和以下客户重复</h4>
            <ul style="
    text-align: left;">
                <li style="line-height:30px" v-for="(item,index) in repeatData" :key="item">
                    {{index+1}} . {{item.name}}--{{item.phone}}--{{item.address}}--{{item.owner?item.owner.name + '(' + item.owner.phone +')':'公共客户'}}
                </li>
            </ul>
        </van-popup>
        <!-- <van-dialog v-model="showRepeat" title="该客户和以下客户重复" show-cancel-button>
          
           <ul>
               <li></li>
           </ul>
        </van-dialog> -->
    </div>
</template>

<script>
import { mapState } from "vuex";
import { validPhone, validEmail, validIdNo } from "@/utils/validate";
import {
    requestJointOrderCustomerAdd,
    requestCityList,
    requestJointOrderPhoneRepeat,
    requestChildStatus,
} from "@/api";
export default {
    name: "jointOrderAdd",
    data() {
        return {
            form: {
                phone: "", //电话
                remark: "", //备注
                cityId:"", //城市id
                areaId:"", //区域id
                name:"",//姓名
                address:"" //详细地址
            },
            repeatData:[],
            showRepeat:false,
            isCheck:false,
            showCity:false,
            cityList:[],
            cityText:"",
            saveLoad: false,
            storeText: "",
            // budgetText: "",
            sourceText: "",
            showStore: false,
            showBudget: false,
            showSource: false,
            showStatus: false,
            showIdType: false,
            showContact: false,
            storeList: [], //门店
            budgetList: [], //期望月租下拉
            sourceList: [], //来源下拉
            trackRecordList: [], //跟进状态下拉
        };
    },
    computed: {
        // ...mapState([
        //     "destineList",
        //     "payList",
        //     "contractList",
        //     "contactList",
        //     "customerList",
        // ]),
    },
    created() {
        // this.getSource();
        // this.getBudget();
        // this.getPCStore();
        // this.getTrackRecord();
        this.getCityList()
    },
    mounted() {},
    methods: {
        //跟踪记录状态
        getTrackRecord() {
            requestChildStatus({ status: "201" }).then((res) => {
                this.trackRecordList = res.data;
            });
        },
        getCityList() {
            requestCityList().then((res) => {
            
             this.cityList = res.data.map((item)=>{
                 return {
                     name:item.name,
                     id:item.id,
                     children:item.childrenList
                 }
             })
              console.log(this.cityList)
            });
        },
        confirmCity(val,index){
            console.log(val,index)
            this.cityText = val.toString()
            this.form.cityId = this.cityList[index[0]].id;
            this.form.areaId = this.cityList[index[0]].children[index[1]].id
            console.log(this.form.cityId,this.form.areaId)
            this.showCity = false
        },
        //新增
        onSubmit() {
            this.saveLoad = true;
            console.log(this.form)
            requestJointOrderCustomerAdd(this.form)
                .then((res) => {
                    this.saveLoad = false;
                    this.$toast.success({
                        message: "新增成功",
                        forbidClick: true,
                        onClose: () => {
                            this.$router.back();
                        },
                    });
                })
                .catch((err) => {
                    this.saveLoad = false;
                    console.log(err);
                });
        },
        //校验
        validPhoneRepeat(val) {
            
            if(!this.isCheck){
                  this.saveLoad = true;
                 return new Promise((resolve) => {
                requestJointOrderPhoneRepeat(val)
                    .then((res) => {
                        this.saveLoad = false;
                        if (res.data && res.data != this.form.id &&res.data.length) {
                            this.showCity = false;
                            
                             this.repeatData = res.data
                              this.isCheck = true
                            this.showRepeat = true
                           
                        } else {
                            resolve(true);
                        }
                    })
                    .catch((err) => {
                        this.saveLoad = false;
                    });
            });
            }
           
                  
        },
        validPhone(val) {
            return validPhone(val);
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
    .remark {
        background: #fff;
        padding: 0.4rem 1rem;
        font-size: 0.35rem;
        text-align: left;
        border-bottom: 1px solid #ececec;
        textarea {
            border: none;
            width: 100%;
            margin-top: 0.2rem;
        }
    }
    .slot {
        .gender {
            * {
                vertical-align: text-bottom;
            }
        }
        .placeholder {
            color: #cccccc;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
/deep/.van-field__error-message {
    text-align: right;
}
</style>
